import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowDropDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_drop_down"}/>
}
